<div class="site-dashboard" [class.site-dashboard--mobile]="device.isMobile()">

  <!-- ── Panel : General information ──────────────────────────────────────── -->
  <div class="site-dashboard__panel">
    @if (canShowStevinRock()) {
      <app-select
        class="site-dashboard__switch"
        size="small"
        [options]="dashboardOptions"
        [ngModel]="selectedDashboard()"
        (selectionChange)="onDashboardChange($event.id)" />
    }

    <app-panel title="General information">

      <div class="info-list" [class.info-list--grid]="device.isMobile()">
        @if (utilService.currentSite(); as site) {
          <div class="info-item">
            <span class="info-item__label">Site name</span>
            <span class="info-item__value">{{ site.nom }}</span>
          </div>
          <div class="info-item">
            <span class="info-item__label">Area name</span>
            <span class="info-item__value">{{ site.region?.nom }}</span>
          </div>
        } @else {
          <span class="info-item__empty">No site selected</span>
        }
      </div>

    </app-panel>
  </div>

  <!-- ── Dashboard Metabase ─────────────────────────────────────────────────── -->
  <div class="site-dashboard__main">
    @if (loadMetabase() && selectedDashboard() === 'site' && currentSiteReady()) {
      <app-metabase-dashboard
        componentSelector="app-dashboard">
      </app-metabase-dashboard>
    } @else if (selectedDashboard() === 'site') {
      <div class="site-dashboard__loading"></div>
    } @else if (loadMetabase() && stevinRockUrl()) {
      <app-metabase-dashboard
        componentSelector="app-mon-site"
        [dashboardUrl]="stevinRockUrl()">
      </app-metabase-dashboard>
    } @else {
      <div class="site-dashboard__loading"></div>
    }
  </div>

</div>
